import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";

const SCROLL_OFFSET = -80;

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return false;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: SCROLL_OFFSET, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  return true;
}

export function scrollToTop() {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}

export function useSectionNavigation() {
  const navigate = useNavigate();
  return (id) => {
    if (window.location.pathname !== "/") {
      sessionStorage.setItem("acScrollTo", id);
      navigate("/");
    } else {
      scrollToSection(id);
    }
  };
}

export function useActiveSection(ids) {
  const [active, setActive] = useState("");
  useEffect(() => {
    const onScroll = () => {
      let current = "";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;
        if (el.getBoundingClientRect().top <= 130) current = id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [ids.join(",")]);
  return active;
}

export function useScrollOnMount() {
  const location = useLocation();
  useEffect(() => {
    const target = sessionStorage.getItem("acScrollTo");
    if (location.pathname === "/" && target) {
      sessionStorage.removeItem("acScrollTo");
      setTimeout(() => scrollToSection(target), 350);
    }
  }, [location.pathname]);
}
